import { render, staticRenderFns } from "./CompanyInformationForm.vue?vue&type=template&id=99dcfda6&scoped=true&"
import script from "./CompanyInformationForm.vue?vue&type=script&lang=js&"
export * from "./CompanyInformationForm.vue?vue&type=script&lang=js&"
import style0 from "./CompanyInformationForm.vue?vue&type=style&index=0&id=99dcfda6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99dcfda6",
  null
  
)

export default component.exports